<script>
export default {
  name: "CountDownItem",
  props: {
    value: {
      type: Number,
      default: 95,
    },
    unit: {
      type: String,
      default: "DAYS",
    },
    max: {
      type: Number,
      default: 100,
    }
  },
  computed: {
    radius() {
      return 32;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    offset() {
      const progress = this.value / this.max;
      return this.circumference * (1 - progress);
    }
  },
  methods: {
    pad(value) {
      return String(value).padStart(2, '0');
    }
  }
}
</script>
<template>
  <div class="countdown-item-wrapper">
    <svg class="progress-ring" width="80" height="80">
      <circle
          class="progress-ring-bg"
          cx="40"
          cy="40"
          r="32"
          fill="rgba(11, 11, 11, 0.5)"
          stroke="rgba(11, 11, 11, 0.6)"
          stroke-width="5"
      />
      <circle
          class="progress-ring-circle"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="offset"
          cx="40"
          cy="40"
          r="32"
          fill="transparent"
          stroke="var(--main-color)"
          stroke-width="5"
          stroke-linecap="square"
      />
    </svg>
    <div class="countdown-item d-flex flex-column justify-content-center align-items-center w-100 h-100">
      <h5 class="item-value text-white m-0 p-0">{{ pad(value) }}</h5>
      <span class="item-unit text-white m-0 p-0 font-weight-lighter">{{ unit }}</span>
    </div>
  </div>
</template>


<style scoped>
.item-value{
  color: white;
  font-family: "sqwaredsemi_bold" !important;
}
.item-unit{
  color: white;
  font-family: "sqwaredthin" !important;
  font-size:8pt;
}
.countdown-item-wrapper {
  width: 80px;
  height: 80px;
  position: relative;

  border-radius: 50%;
}
.progress-ring {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg);

}
.progress-ring-circle {
  transition: stroke-dashoffset 0.35s ease;
  transform-origin: center;
}
.countdown-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
}
.item-value {
  font-family: "sqwaredsemi_bold" !important;
}
.item-unit {
  font-family: "sqwaredregular" !important;
  font-size: 8pt;
}
</style>